module.exports = __webpack_public_path__ + "static/media/add-with-circle.0bef70aa.svg";